const navigation = [
  { name: "Home", to: "/" },
  {
    name: "About Us",
    to: "/about",
    hasDropdown: true,
    dropdownItems: [
      {
        name: "About Barma Sorig",
        to: "/about#barma-sorig",
      },
      {
        name: "Ku Nye",
        to: "/kuNye",
      },
      {
        name: "Nine Breathing Exercise",
        to: "/nineBreathingExercise",
      },
      {
        name: "Mission & Vision",
        to: "/about#mission-vision",
      },
      {
        name: "Staff Organogram",
        to: "/about#staff",
      },
    ],
  },
  {
    name: "Services",
    to: "/services",
    hasDropdown: true,
    dropdownItems: [
      {
        name: "Ku-Nye Services",
        subServices: [
          {
            name: "Whole Body Massage",
            to: "/services?service=Ku-Nye Services&category=Whole Body Ku Nye Massage",
          },
          {
            name: "Head & Facial Massage",
            to: "/services?service=Ku-Nye Services&category=Head, Face and Foot Massage",
          },
          {
            name: "Herbal Steam",
            to: "/services?service=Ku-Nye Services&category=Herbal Steam (Amrita's)",
          },
        ],
      },
      {
        name: "Salon Services",
        subServices: [
          {
            name: "Hair Care",
            to: "/services?service=Salon Services&category=Hair Care",
          },
          {
            name: "Face & Brows",
            to: "/services?service=Salon Services&category=Face and Brows",
          },
          {
            name: "Waxing",
            to: "/services?service=Salon Services&category=Waxing",
          },
          {
            name: "Hands & Feet",
            to: "/services?service=Salon Services&category=Hands and Feet",
          },
        ],
      },
    ],
  },
  {
    name: "Gallery",
    to: "/gallery",
  },
  {
    name: "Career",
    to: "/career",
    hasDropdown: true,
    dropdownItems: [
      {
        name: "Short Term Course",
        to: "/career#Short_Term_Course",
      },
      {
        name: "Membership",
        to: "/career#Membership",
      },
      {
        name: "Vacancy",
        to: "/career#Vacancy",
      },
      {
        name: "Downloads",
        to: "/career#downloads",
      },
    ],
  },
  { name: "Contact", to: "/contact" },
];

export default navigation;
